(function () {
  function initScrollToTop() {
    const button = document.getElementById('ScrollToTop');

    if (!button) return;

    let scrollContainer = window;

    function findScrollContainer() {
      let element = document.querySelector('main');

      while (element && element !== document.body) {
        const style = window.getComputedStyle(element);
        const canScroll =
          (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
          element.scrollHeight > element.clientHeight;

        if (canScroll) {
          return element;
        }

        element = element.parentElement;
      }

      return window;
    }

    scrollContainer = findScrollContainer();

    function getScrollPosition() {
      if (scrollContainer === window) {
        return Math.max(
          window.scrollY,
          document.documentElement.scrollTop,
          document.body.scrollTop
        );
      }

      return scrollContainer.scrollTop;
    }

    function updateButton() {
      if (getScrollPosition() > 300) {
        button.classList.add('show');
      } else {
        button.classList.remove('show');
      }
    }

    scrollContainer.addEventListener('scroll', updateButton, {
      passive: true
    });

    button.addEventListener('click', function () {
      if (scrollContainer === window) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });

    updateButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToTop);
  } else {
    initScrollToTop();
  }
})();